import { IRootState } from '../interfaces/IRootState';

export const getCoreIsLoading = (state: IRootState) => state.core.loading > 0;
export const getCoreHeight = (state: IRootState) => state.core.height;
export const getCoreScreenSize = (state: IRootState) => state.core.screenSize;
export const getCoreLoginPageUrl = (state: IRootState) => state.core.loginPageUrl;
